import { render } from "./ContentToDownloadRemittance.vue?vue&type=template&id=4bf04755"
import script from "./ContentToDownloadRemittance.vue?vue&type=script&lang=js"
export * from "./ContentToDownloadRemittance.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__